import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {LoadingComponent} from './components/loading/loading.component';
import {FileDownloadComponent} from './components/file_download/file_download.component';

import {FileDownloadService} from './components/file_download/file_download.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RazonSocialService} from './service/razon-social.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [
        LoadingComponent,
        FileDownloadComponent,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        FileDownloadService,
        RazonSocialService
    ],
    declarations: [LoadingComponent, FileDownloadComponent]
})

export class SharedModule {
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/shared/shared.module.ts